module.exports = __webpack_public_path__ + "img/bentley_1.7949f601.png";